import { useAuth0 } from "@auth0/auth0-react";
import { IconButton, TableContainer, TableRow } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import { Pagination } from "@material-ui/lab";
import { ReactComponent as FilterIcon } from "assets/icons/Filter.svg";
import { ReactComponent as SortIcon } from "assets/icons/SortIcon.svg";
import Action from "components/ActionPopOver";
import Button from "components/button/Button";
import AlertDialog from "components/Dialog";
import Loader from "components/loader/Loader";
import MyButton from "components/MyButton";
import MyFilterButton from "components/MyFilterButton";
import SearchComp from "components/Searchcomponent";
import { formatDate } from "helper/dateFormat";
import CommunicationService from "Lib/API/Communication";
import moment from "moment";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  setAutomationEditData,
  setCardContent,
  setCreateAutomationDialog,
  setFormTemplateCampainPage,
  setOpenTemplateCreationDialog,
  setPreviewTemplete,
  setSelectedTemplate,
} from "services/api/communication";
import { CreateAutomation } from "./CreateAutomation/CreateAutomation";
import { AudiencesNames, Content, SearchWrapper, StatusWrapper, Title } from "./Theme";
import { fontConfig } from "theme/fontConfig";

export const AutomationTable = ({
  setToggle,
  atomationList,
  page,
  setPage,
  loading,
  onSortChange,
  searchValue,
  handleInputChange,
  count,
  handleSort,
  refresh,
  setRefresh,
  setCampainDetailsId,
}) => {
  const headerTitles = [
    { title: "AUTOMATION NAME", sortName: "automationName" },
    { title: "EVENT TYPE", sortName: "eventType" },
    { title: "DATE CREATED", sortName: "createdAt" },
    { title: "STATUS", sortName: "status" },
    { title: "WHEN" },
    { title: "AUDIENCES"},
    { title: "SELECTED TEMPLATE" },
    { title: "", className: "sticky-header-column" },
  ];
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [deleteCapmaignId, setDeleteCapmaignId] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [duplicateAutomationId, setDuplicateAutomationId] = useState(null);
  const [confirmClose, setConfirmClose] = useState(false);
  const { createAutomationDialog } = useSelector(
    (state) => state.communication
  );
  const TableCellHead = withStyles((theme) => ({
    root: {
      height: "39px",
      padding: "0px 20px",
      borderBottom: "none",
      fontFamily: fontConfig.GeneralTableCellHeadFont.family,
    },
  }))(TableCell);
  const TableCellBody = withStyles((theme) => ({
    root: {
      height: "65px",
      padding: "0px 20px",
      fontFamily: fontConfig.GeneralTableCellBodyFont.family,
      fontSize: "14px",
      color: "#4f4f4f",
    },
  }))(TableCell);
  const useStyles = makeStyles({
    tableRow: {
      "&:hover": {
        boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        backgroundColor: "#e6ecf05e",
        cursor: "pointer",
      },
    },
  });

  const deleteCapmaign = async (id) => {
    setConfirmLoading(true);
    try {
      const token = await getAccessTokenSilently();
      const result = await CommunicationService.deleteAutomation(token, id);
      toastr.success("Success", "Automation Deleted Successfully!");

      setRefresh(!refresh);
    } catch (err) {
      toastr.error("Error", err?.data?.message);
    } finally {
      setConfirmLoading(false);
      setDeleteCapmaignId(null);
      setConfirmDialog(false);
    }
  };
  const duplicateCapmaign = async () => {
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      await CommunicationService.duplicateAutomation(
        token,
        duplicateAutomationId
      );
      toastr.success("Success", "Capmaign Duplicated Successfully!");
      setRefresh(!refresh);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong!");
    } finally {
      setDuplicateAutomationId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
    }
  };
  const handlePauseStartAction = async (status, id) => {
    const pauseOrStart=
     status === "active"
        ? "paused"
        : status === "paused"
        ? "active"
        : ""
    console.log('pauseOrStart', pauseOrStart)
    const data = {
      id: id,
      status: pauseOrStart,
    };

    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      const result = await CommunicationService.activeAutomation(token, data);

      toastr.success("Success", "Update Successfully!");
      setRefresh(!refresh);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong!");
    } finally {
      setDuplicateAutomationId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
    }
  };

  const closeModal = () => {
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    dispatch(setCreateAutomationDialog(false));
  }
  


  return (
    <>
      <Content>
        <div>
          <Title>Automations</Title>
          <MyFilterButton
            className="campaign_filter"
            title="All"
            items={[
              { label: "Draft", value: "draft" },
              { label: "Paused", value: "paused" },
              { label: "Active", value: "active" },
              { label: "All", value: "all" },
            ]}
            icon={<FilterIcon style={{ width: "19px", height: "17px" }} />}
            onChange={onSortChange}
          />
          <SearchWrapper>
            <SearchComp
              value={searchValue}
              setSearchText={handleInputChange}
              placeholder="Search"
              style={{ width: "20.5rem", backgroundColor: "#fff" }}
            />
          </SearchWrapper>
        </div>
        <Button
            variant="primary"
            onClick={() => {
              dispatch(setCreateAutomationDialog(true));
              dispatch(setCardContent(""));
              dispatch(setAutomationEditData({}));
            }}
            style={{
              marginRight: "20px",
            }}
            size="md"
          >
            <span>Create Automation</span>
        </Button>
      </Content>

      <>
        <div
          style={{ paddingLeft: "17px", paddingRight: "17px", marginTop: 20 }}
        >
          <TableContainer className="scroll-table">
            <Table aria-label="collapsible table ">
              <TableHead className="charges-table sticky-table-header">
                <TableRow>
                  {headerTitles.map((item) => (
                    <TableCellHead
                      className={`class__header__cell className_head ${item?.className}`}
                      key={item?.title}
                    >
                      <div>
                        {item?.title}
                        {item?.sortName && (
                          <IconButton>
                            <SortIcon
                              onClick={() => handleSort(item?.sortName)}
                            />
                          </IconButton>
                        )}
                      </div>
                    </TableCellHead>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody
                style={{
                  backgroundColor: "white",
                }}
              >
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <div className="user__loader" style={{ height: "320px" }}>
                        <Loader />
                      </div>
                    </TableCell>
                  </TableRow>
                ) : atomationList?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <h6 style={{ height: "320px", marginTop: "100px" }}>
                        No Automation Found
                      </h6>
                    </TableCell>
                  </TableRow>
                ) : (
                  atomationList?.map((row, i) => (
                    <React.Fragment key={row?._id}>
                      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                        <TableCellBody
                          className="status-head main-width-class"
                          component="th"
                          scope="row"
                          onClick={() => {
                            setCampainDetailsId(row?._id);
                          }}
                        >
                          {row?.automationName}
                        </TableCellBody>
                        <TableCellBody
                          className="main-width-class"
                          align="left"
                        >
                          {row?.eventType}
                        </TableCellBody>
                        <TableCellBody
                          className="transaction-head main-width-class"
                          align="left"
                        >
                          {row?.createdAt && formatDate({date:row?.createdAt, formatType: "defaultWithUTC"})}
                        </TableCellBody>
                        <TableCellBody
                          style={{
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                          }}
                          className="paid-head main-width-class"
                          align="left"
                        >
                          <StatusWrapper status={row?.status}>
                            {row?.status &&
                              row?.status[0]?.toString()?.toUpperCase() +
                                row?.status.slice(1)}
                          </StatusWrapper>
                        </TableCellBody>

                        <TableCellBody
                          style={{
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                          }}
                          className="paid-head main-width-class"
                          align="left"
                        >
                          <div
                            style={{
                              minWidth: "100px"
                            }}
                          >
                            {row?.timeExecute?.unit > 0 && `${row?.timeExecute?.unit} `}
                            {row?.timeExecute?.timePeriod}{" "}
                            {row?.timeExecute?.timeType}
                          </div>
                        </TableCellBody>
                        <TableCellBody
                          style={{
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                          }}
                          className="paid-head main-width-class"
                          align="left"
                        >
                          <AudiencesNames>
                          { row?.audiences.map(audience => audience.name)?.join(', ')}

                          </AudiencesNames>
                    
                        </TableCellBody>
                        <TableCellBody
                          className="status-head main-width-class"
                          component="th"
                          scope="row"
                          onClick={() => {
                            if (row?.automationType !== "sms" && row?.automationType !== "push") {
                              setToggle("Templates");
                              dispatch(setOpenTemplateCreationDialog(true));
                              dispatch(setPreviewTemplete(true));
                              dispatch(
                                setFormTemplateCampainPage(row?.template)
                              );
                            }
                          }}
                        >
                          {row?.automationType === "sms" ? (
                            <span>Text Message</span>
                          ) : row?.automationType === "push" ? (
                            <span>Push Notification</span>
                          ) : (
                            <div className="transaction-status">
                              <div style={{ width: 22 }}></div>
                              <div className="pl-0">
                                <div className="school-table-class-name">
                                  {row?.template?.title}
                                </div>
                              </div>
                            </div>
                          )}
                        </TableCellBody>

                        <TableCellBody
                          className="exp-action-head main-width-class sticky-body-column"
                          align="right"
                        >
                          <div
                            style={{
                              cursor: "pointer",
                              paddingleft: "0px",
                              zIndex: 1000,
                            }}
                          >
                            <Action
                              action="communication"
                              style={{ width: "16px" }}
                              onEditClick={() => {
                                const cardCon =
                                  row?.automationType === "sms"
                                    ? "Text message"
                                    : row?.automationType === "push"
                                    ? "Push notification"
                                    : "My template";
                                dispatch(setCreateAutomationDialog(true));
                                dispatch(setCardContent(cardCon));
                                dispatch(setAutomationEditData(row));
                                dispatch(setSelectedTemplate(row?.template || {}));
                              }}
                              isEditHide={row?.status === "active"}
                              onPauseStart={() => {
                                handlePauseStartAction(row?.status, row?._id);
                              }}
                              pauseOrStart={
                                row?.status === "active"
                                  ? "Pause"
                                  : row?.status === "paused"
                                  ? "Active"
                                  : ""
                              }
                              onDeleteClick={() => {
                                setDeleteCapmaignId(row?._id);
                                setConfirmDialog(true);
                              }}
                              onDuplicateClick={() => {
                                setDuplicateAutomationId(row?._id);
                                setConfirmDialog(true);
                              }}
                            />
                          </div>
                        </TableCellBody>
                      </TableRow>
                    </React.Fragment>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {atomationList?.length > 0 && (
          <div className="pagination-custom mt-9">
            <Pagination
              count={Math.ceil(count / 30)}
              color="primary"
              variant="outlined"
              page={page + 1}
              onChange={(event, value) => {
                setPage(value - 1);
              }}
            />
          </div>
        )}
      </>
      <AlertDialog
        open={confirmDialog}
        onDecline={() => {
          if (deleteCapmaignId) {
            setDeleteCapmaignId(null);
          }
          if (duplicateAutomationId) {
            setDuplicateAutomationId(null);
          }
          setConfirmDialog(false);
        }}
        onAccept={() => {
          if (deleteCapmaignId) {
            deleteCapmaign(deleteCapmaignId);
          }
          if (duplicateAutomationId) {
            duplicateCapmaign(duplicateAutomationId);
          }
        }}
        title={"Are you sure?"}
        description={`Do you want to ${
          duplicateAutomationId ? "duplicate" : "delete"
        } this automation?`}
        disabled={confirmLoading}
      />
      <Dialog
        open={createAutomationDialog}
        onClose={closeModal}
        sx={{ width: "1500px" }}
        PaperProps={{
          style: {
            width: "1500px",
            overflowX: "hidden",
            borderRadius: "10px",
            marginButton: "20px",
          },
        }}
        fullWidth
        maxWidth={"lg"}
      >
        <CreateAutomation
          setToggle={setToggle}
          setRefresh={setRefresh}
          refresh={refresh}
        />
      </Dialog>
      <AlertDialog
        open={confirmClose}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
    </>
  );
};
